import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LOGO_PATH_ONLY_MASCOTTE } from 'src/app/constants';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { InAppBrowserOptions, InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@Component({
  selector: 'app-thankyou-subscription',
  templateUrl: './thankyou-subscription.page.html',
  styleUrls: ['./thankyou-subscription.page.scss'],
})
export class ThankYouSubscriptionPage implements OnInit {

  logoPath = LOGO_PATH_ONLY_MASCOTTE;
  isCreating = false;
  expiration = moment().add(1, 'years');

  constructor(
    private profileService: ProfileService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private spinner: SpinnerService,
    private auth: AuthService,
    private platform: Platform,
    private iab: InAppBrowser,
    private translate: TranslateService,) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams
      .subscribe((params) => {
        this.isCreating = params && params.isCreating;
      });
  }

  ok() {
    if (this.isCreating) {
      this.createStripeConnectAccountLink();
      // this.router.navigate(['/identity-card'], { replaceUrl: true, queryParams: { isCreating: 'true' } });
    } else {
      this.router.navigate(['/profile'], { replaceUrl: true, queryParams: { segment: '2' } });
    }
  }

  async createStripeConnectAccountLink(openInTab: boolean = false) {
    try {
      await this.spinner.show();
      const token = await this.auth.getToken();
      const body = await this.profileService.getStripeConnectAccountLink(token);
      await this.spinner.dismiss();

      const url = body.accountLink;

      if (!this.platform.is('cordova')) {
        if (openInTab) {
          window.open(url, '_blank');
        } else {
          window.open(url, '_self');
        }
        return;
      }
  
      const CLOSE = await this.translate.get('CLOSE').toPromise();
  
      const options: InAppBrowserOptions = {
        location: 'no',
        hidenavigationbuttons: 'yes',
        closebuttoncaption: CLOSE,
        usewkwebview: 'yes',
        cleardata: 'yes',
      };
  
      const browser = this.iab.create(url, '_blank', options);
      browser.on('loadstart').subscribe(async (e) => {
        if (e.url.includes('success')) {
          browser.close();
          this.onStripeConnectAccountCreationSuccess();
        } else if (e.url.includes('error')) {
          browser.close();
          this.onStripeConnectAccountCreationError();
        } else if (e.url.includes('cancel') || e.url.includes('home')) {
          browser.close();
          this.onStripeConnectAccountCreationError();
        }
      });
    } catch (err) {
      
      await this.spinner.dismissWithAlertError(err);
    }
  }

  async onStripeConnectAccountCreationSuccess() {
    this.router.navigate(['/profile', ], { replaceUrl: true, queryParams: { segment: '2' } });
  }

  async onStripeConnectAccountCreationError() {
    this.router.navigate(['/profile'], { replaceUrl: true, queryParams: { segment: '2' } });
  }

}
